/**
 * IMPORTS
 */

import { ICreateClientAddressPayload } from "@/hooks/enderecos/criar/index.d";

import { enderecoRepository } from "@/repositories/enderecos-usuarios";

/*
 * Função que criar dados de endereço para cliente 🛠️.
 */
const handleCreateNovoEndereco = async (
  accessToken: string,
  payload: ICreateClientAddressPayload
) => {
  try {
    const data = await enderecoRepository.criarNovoEndereco(accessToken, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR AO CRIAR CLIENTES: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleCreateNovoEndereco };
